import {environment} from '../../../environments/environment';
import {ConfigService} from './config.service';

export const EnvServiceFactory = () => {
  return environment;
};

export const ConfigServiceProvider = {
  provide: ConfigService,
  useFactory: EnvServiceFactory,
  deps: [],
};
